import { Box, Stack } from "@mui/material";
import CardDsfrContext from "components/CardDsfrContext";
import DSFRListContext from "components/DSFRListContext";
import Wrapper from "components/LayoutFront/Wrapper";
import TemplateBanner from "components/templatesComponents/TemplateBanner";
import { useGetAllSites } from "hooks/site.hook";
import PropTypes from "prop-types";
import React, { useMemo } from "react";

const ProcessesDsfr = (props) => {
  const { page: pageVersion = {} } = props;

  const { contents, page, shortDescription, title } = pageVersion;

  const { siteId } = page;

  const { dynamicList, dsfrCards, showLogo } = contents;

  const { data: allSites = [] } = useGetAllSites();

  const findSiteById = useMemo(() => allSites?.find((site) => site.id === siteId), [allSites, siteId]);

  const { name: siteNameById } = findSiteById || {};

  const cardDsfrContextValue = useMemo(() => ({ hasGreyBackground: true, showDescription: true }), []);
  const dsfrListContextValue = useMemo(() => ({ xs: 12, sm: 6, lg: 4 }), []);

  const bo = useMemo(() => typeof showLogo === "object", [showLogo]);

  return (
    <>
      <TemplateBanner bo={bo}>
        <Stack direction={{ lg: "row" }} sx={{ alignItems: "flex-start", gap: 2 }}>
          {bo || (showLogo && siteNameById) ? (
            <Box
              component="img"
              src={`/logo-${siteNameById}.svg`}
              alt=""
              sx={{
                ...(bo ? { opacity: showLogo.props?.content?.value === "true" ? 1 : 0.3 } : {}),
                width: "95px",
              }}
            />
          ) : null}
          <Stack sx={{ flexGrow: 1 }}>
            <h1>{title}</h1>
            {shortDescription && <p className="fr-text--xl">{shortDescription}</p>}
            {dynamicList && (
              <Stack direction={{ lg: "row" }} sx={{ gap: 2, mb: 2, "& a": { width: { xs: "100%", lg: "auto" } } }}>
                {dynamicList}
              </Stack>
            )}
          </Stack>
        </Stack>
        {bo ? <Box>{showLogo}</Box> : null}
      </TemplateBanner>
      <Wrapper>
        <DSFRListContext.Provider value={dsfrListContextValue}>
          <CardDsfrContext.Provider value={cardDsfrContextValue}>{dsfrCards}</CardDsfrContext.Provider>
        </DSFRListContext.Provider>
      </Wrapper>
    </>
  );
};

ProcessesDsfr.propTypes = {
  page: PropTypes.shape(),
};

export default ProcessesDsfr;
